import { render, staticRenderFns } from "./TableGeoNovation.vue?vue&type=template&id=452ea64a&"
import script from "./TableGeoNovation.vue?vue&type=script&lang=js&"
export * from "./TableGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports